/**
 * Anzeige-Form eines Kategorienamens: jeder Wortanfang groß, Bindestrich zählt als
 * Wortgrenze („synergy-counterspell" → „Synergy-Counterspell"). Gespeichert werden Namen
 * klein (erzwingt das Backend). Einzige Quelle dieser Regel — keine CSS-Großschreibung
 * per Text-Transform irgendwo in frontend/src (der Konventions-Check prüft das).
 */
export function formatCategoryName(name) {
  if (!name) return '';
  return name.replace(/(^|[\s-])(\S)/g, (_, vor, zeichen) => vor + zeichen.toUpperCase());
}
